import { all, call, fork, put, select, take } from "redux-saga/effects";
import { toast } from "react-toastify";
import { uniqBy } from "lodash";

import { getJSONFileApi, addSaleApi } from "src/apiService";
import {
  addSaleFromInventory,
  addBundledSales,
} from "src/apiService/modules/sales";
import {
  setEbayExtraRows,
  setPendingUploads,
  setUploadsFromEbay,
  LOAD_SYNC_SALES,
} from "./actions";
import { getAllSales } from "./selector";
import { parseError } from "src/utils";
import { transforms, transformSale } from "src/utils/uploadTransform";

import {
  SALE,
  BUNDLED_SALES,
  FAIL,
  START,
  SUCCESS,
  CREATE_ITEM,
} from "../common";
import { getNewSyncSalesDownloads } from "../uploads/selector";
import { getTransactions } from "../transaction/selector";

function* createSale() {
  while (true) {
    const { payload } = yield take(SALE + CREATE_ITEM + START);
    try {
      if (payload && payload.id) {
        yield call(addSaleFromInventory, payload.id, payload);
      } else {
        yield call(addSaleApi, payload);
      }
      yield put({ type: SALE + CREATE_ITEM + SUCCESS, payload });
      toast.success("Sale has been added successfully!");
    } catch (error) {
      toast.error(parseError(error));
      yield put({
        type: SALE + CREATE_ITEM + FAIL,
        payload: parseError(error),
      });
    }
  }
}

function* createBundledSales() {
  while (true) {
    const { payload } = yield take(BUNDLED_SALES + CREATE_ITEM + START);
    try {
      yield call(addBundledSales, payload);
      yield put({ type: SALE + CREATE_ITEM + SUCCESS, payload });
      toast.success("Sale has been added successfully!");
    } catch (error) {
      toast.error(parseError(error));
      yield put({
        type: SALE + CREATE_ITEM + FAIL,
        payload: parseError(error),
      });
    }
  }
}

function* loadSyncSales() {
  while (true) {
    yield take(LOAD_SYNC_SALES + START);
    try {
      const existingSales = yield select(getAllSales);
      const existingTransactions = yield select(getTransactions);
      const downloads = yield select(getNewSyncSalesDownloads);
      const rawData = yield all(
        downloads.map((download) => getJSONFileApi(download.filename))
      );
      const flatRawData = rawData.flat();
      const uniqueRawData = uniqBy(flatRawData, "transactionId");
      console.log({ flatRawData, uniqueRawData });
      const transformed = uniqueRawData.map(transforms.ebaySalesDirectImport);
      const flattened = transformed.flat();
      const mapped = flattened.map(transformSale);
      const filtered = mapped.filter(
        (newItem) =>
          !existingSales.find(
            (item) => item.transaction_id === newItem.transaction_id
          )
      );
      const uniqued = uniqBy(filtered, "transaction_id");
      const finalMap = uniqued.map((item, uploadIndex) => ({
        ...item,
        uploadIndex,
      }));
      const extraRows: any[] = uniqueRawData
        .map(transforms.ebaySalesExtraRows)
        .flat();
      let removedExistingTransactions = extraRows;
      console.log(existingTransactions);
      if (existingTransactions.items.length > 0) {
        removedExistingTransactions = extraRows.filter(
          (newTransaction) =>
            !existingTransactions.items.find(
              (item) => item.transactionId === newTransaction.transactionId
            )
        );
      }
      const uniqueExtraRows = uniqBy(
        removedExistingTransactions,
        "transactionId"
      );
      const returns: any[] = uniqueRawData
        .map(transforms.ebaySalesReturns)
        .flat();
      const uniqueReturns = uniqBy(returns, "Return ID");
      yield put(setPendingUploads(finalMap));
      yield put(
        setEbayExtraRows({ extraRows: uniqueExtraRows, returns: uniqueReturns })
      );
      yield put(setUploadsFromEbay(true));
    } catch {}
  }
}

export function* saleSagas() {
  yield all([fork(createSale), fork(createBundledSales), fork(loadSyncSales)]);
}
